import { ListarTipoTelefoneService } from "../../../Services/Geral/TipoTelefone/TipoTelefoneServices";
import { Controller } from "../../Controller";

export const ListarTipoTelefoneController = () =>
    Controller(ListarTipoTelefoneService());
